import dict from './dict';
import config from './config';

export default {
    sys_manage: { routerName: 'システム管理' },
    ...dict,
    ...config,
};
